import { render } from "./ReviewTmp.vue?vue&type=template&id=5e395c28&scoped=true"
import script from "./ReviewTmp.vue?vue&type=script&lang=js"
export * from "./ReviewTmp.vue?vue&type=script&lang=js"

import "./ReviewTmp.vue?vue&type=style&index=0&id=5e395c28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e395c28"]])

export default __exports__